import { Phone, Mail, MapPin, Linkedin } from "lucide-react";
import logo from "../../assets/gramagec-logo.png";
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Accueil", href: "#accueil" },
    { label: "À Propos", href: "#apropos" },
    { label: "Projets", href: "#projets" },
    { label: "Services", href: "#services" },
    { label: "Clients", href: "#clients" },
    { label: "Contact", href: "#contact" },
  ];

  const services = [
    "Travaux de Voirie",
    "Assainissement",
    "Adduction Eau Potable",
    "Électrification",
    "Éclairage Public",
    "Location Matériel",
  ];

  return (
    <footer className="bg-dark-gradient-mobile md:bg-dark-gradient text-primary-foreground pt-16 pb-8">
      <div className="container-custom px-4 md:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img src={logo} alt="logo" width={170} />
            </div>
            <p className="text-primary-foreground/70 text-sm leading-relaxed mb-6">
              Depuis 2015, GRAMAGEC accompagne les plus grands projets de
              construction au Maroc avec professionnalisme et expertise.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">
              Liens Rapides
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">
              Nos Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-primary-foreground/70 text-sm">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="space-y-3">
              <h4 className="font-heading font-semibold text-lg mb-6">
                Contactez-nous
              </h4>
              <a
                href="tel:++212522974370"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                <Phone className="w-4 h-4" />
                +212 5 22 97 43 70
              </a>
              <a
                href="mailto:contact@gramagec.com"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                <Mail className="w-4 h-4" />
                contact@gramagec.com
              </a>
              <div className="flex items-start gap-3 text-primary-foreground/70 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                Green Works Center, Batiment D,2ème étage bureau 8, Route de
                bouskoura Casablanca, Maroc
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-primary-foreground/50 text-sm text-center md:text-left">
              © {currentYear} GRAMAGEC. Tous droits réservés.
            </p>
            <div className="text-primary-foreground/70 text-sm hover:text-secondary">
              <a
                href="https://www.linkedin.com/company/gramagec-grands-maroc-de-g%C3%A9nie-civil/?originalSubdomain=ma"
                rel="noopener noreferrer"
                target="_blank">
                <Linkedin className="w-5 h-5 mt-0.5 flex-shrink-0" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
